import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M2.46286 0.917334L11.7078 10.0542C12.0974 10.4388 12.0974 11.0602 11.7078 11.4458L2.46286 20.5827C1.90053 21.1391 0.985625 21.1391 0.422296 20.5827C-0.140034 20.0262 -0.140034 19.1231 0.422296 18.5667L8.33087 10.7495L0.422295 2.93432C-0.140035 2.37688 -0.140035 1.47378 0.422295 0.917335C0.985623 0.36089 1.90053 0.36089 2.46286 0.917334Z"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_as_icon_base = _resolveComponent("as-icon-base")!

  return (_openBlock(), _createBlock(_component_as_icon_base, _mergeProps(_ctx.$attrs, {
    width: "12",
    height: "21",
    viewBox: "0 0 12 21",
    fill: "none"
  }), {
    default: _withCtx(() => [
      _hoisted_1
    ]),
    _: 1
  }, 16))
}